import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from 'store/index'
import 'style/global.less';
import App from './App';



ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="xnyeyweb">
      <Suspense fallback={<div></div>}>
      <Switch>
          <Route path="/" render={routerProps => {
            return <App {...routerProps}/>
          }}/>
        </Switch>
      </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

